import { Breadcrumb, Col, DatePicker, Form, Row, Select, Spin, Tooltip } from 'antd'
import { Trans, useTranslation } from "react-i18next";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import React from 'react'
import { t } from 'i18next';
import { Link } from 'react-router-dom';
import Chart from 'react-apexcharts';
import { Card } from 'antd';

const PriceTrandReport = () => {
    const { t } = useTranslation();
    const options = {
        chart: {
            id: 'basic-bar',
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        },
    };

    const series = [
        {
            name: 'Series 1',
            data: [30, 40, 35, 50, 49, 60],
        },
    ];
    const colors = ["#094E8F"];
    return (
        <>
            <div className="ListingTopBar">
                <div className="pagenamewrap">
                    <div className="pagename">
                        <Tooltip
                            color={colors}
                            placement="right"
                            title={
                                <span style={{ color: "#fff" }}>
                                    Visualize Item , State, City and Date wise specific procurement data
                                    using charts and graphs for easier interpretation and analysis.
                                </span>
                            }
                        >
                            <h3>Price Trend Report</h3>
                        </Tooltip>
                        <Breadcrumb className="Breadcrumb-Sec">
                            <Breadcrumb.Item>
                                <Link to="/dashboard">{t("home")}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                Reports
                            </Breadcrumb.Item>
                            <Breadcrumb.Item> Price Trand Report</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </div>

            <div>
                <section className="grid-sec FormSection Container">
                    <div className="FormBody">

                        <Row gutter={[16]}>
                            <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                                xl={6}
                                className="TextFeild gutter-row"
                            >
                                <Form.Item name="joining_date" label="Date">
                                    <DatePicker
                                        showTime
                                        format="DD-MM-YYYY"
                                    // onChange={(date, dateString) =>
                                    //     handleDatepickerChange(date, dateString, "joining_date")
                                    // }
                                    // value={
                                    //     state.joining_date
                                    //         ? moment(state.joining_date, "DD-MM-YYYY")
                                    //         : null
                                    // }
                                    />
                                </Form.Item>
                            </Col>
                            <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                                xl={6}
                                className="TextFeild gutter-row"
                            >
                                <Form.Item
                                    name='city'
                                    label="City"
                                    className="cust-selectBox"
                                // rules={[
                                //     {
                                //         required: true,
                                //         message: (
                                //             <Trans>
                                //                 {t("val_category_wise_WBS_number")}
                                //             </Trans>
                                //         ),
                                //     },
                                // ]}
                                >
                                    <Select
                                        showArrow
                                        showSearch
                                        allowClear
                                        placeholder="Select City"
                                        optionFilterProp="children"

                                    // onChange={(value) =>
                                    //     handleCloneSelectChange(
                                    //         "category",
                                    //         value,
                                    //         index
                                    //     )
                                    // }
                                    >
                                        {/* {categoryTree &&
                        categoryTree.length > 0 &&
                        categoryTree.map((item) => (
                            <Select.Option
                                key={item.id}
                                value={item.id}
                            >
                                {item.name}
                            </Select.Option>
                        ))} */}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                                xl={6}
                                className="TextFeild gutter-row"
                            >
                                <Form.Item
                                    name='state'
                                    label="State"
                                    className="cust-selectBox"
                                // rules={[
                                //     {
                                //         required: true,
                                //         message: (
                                //             <Trans>
                                //                 {t("val_category_wise_WBS_number")}
                                //             </Trans>
                                //         ),
                                //     },
                                // ]}
                                >
                                    <Select
                                        showArrow
                                        showSearch
                                        allowClear
                                        placeholder="Select State"
                                        optionFilterProp="children"

                                    // onChange={(value) =>
                                    //     handleCloneSelectChange(
                                    //         "category",
                                    //         value,
                                    //         index
                                    //     )
                                    // }
                                    >
                                        {/* {categoryTree &&
                        categoryTree.length > 0 &&
                        categoryTree.map((item) => (
                            <Select.Option
                                key={item.id}
                                value={item.id}
                            >
                                {item.name}
                            </Select.Option>
                        ))} */}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                                xl={6}
                                className="TextFeild gutter-row"
                            >
                                <Form.Item
                                    name='item'
                                    label="Item"
                                    className="cust-selectBox"
                                // rules={[
                                //     {
                                //         required: true,
                                //         message: (
                                //             <Trans>
                                //                 {t("val_category_wise_WBS_number")}
                                //             </Trans>
                                //         ),
                                //     },
                                // ]}
                                >
                                    <Select
                                        showArrow
                                        showSearch
                                        allowClear
                                        placeholder="Select Item"
                                        optionFilterProp="children"

                                    // onChange={(value) =>
                                    //     handleCloneSelectChange(
                                    //         "category",
                                    //         value,
                                    //         index
                                    //     )
                                    // }
                                    >
                                        {/* {categoryTree &&
                        categoryTree.length > 0 &&
                        categoryTree.map((item) => (
                            <Select.Option
                                key={item.id}
                                value={item.id}
                            >
                                {item.name}
                            </Select.Option>
                        ))} */}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                                xl={6}
                                className="TextFeild gutter-row"
                            >
                                <Form.Item
                                    name='days'
                                    label="Days"
                                    className="cust-selectBox"
                                // rules={[
                                //     {
                                //         required: true,
                                //         message: (
                                //             <Trans>
                                //                 {t("val_category_wise_WBS_number")}
                                //             </Trans>
                                //         ),
                                //     },
                                // ]}
                                >
                                    <Select
                                        showArrow
                                        showSearch
                                        allowClear
                                        placeholder="Select Days"
                                        // onChange={(value) =>
                                        //     handleSelectChange("unit_of_measurement", value)
                                        // }
                                        optionFilterProp="children"
                                    >
                                        <Select.Option value="7">7 - Days</Select.Option>
                                        <Select.Option value="15">15 - Days</Select.Option>
                                        <Select.Option value="30">30 - Days</Select.Option>
                                        <Select.Option value="60">60 - Days</Select.Option>
                                        <Select.Option value="90">90 - Days</Select.Option>
                                        <Select.Option value="6">6 Month</Select.Option>
                                        <Select.Option value="year">Year</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                        </Row>

                        <Row gutter={[16]}>
                            <Col
                                xs={24}
                                sm={24}
                                md={24}
                                lg={6}
                                xl={9}
                                className="TextFeild gutter-row"
                            >

                                <Card title="Graph" className="ChartCard">
                                    <Chart options={options} series={series} type="bar" height={270} width={400} />
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </section>
            </div>
        </>
    )
}

export default PriceTrandReport